/**
 * Le seul JavaScript des écrans Devise : révéler le mot de passe saisi.
 *
 * Un entrypoint à part et non un ajout à `inertia.tsx` : ces écrans ne passent
 * pas par Inertia - ils sont servis en ERB par le gabarit `auth` -, et charger
 * React sur la page de connexion pour un bouton oeil serait payer 150 Ko pour
 * quinze lignes.
 *
 * **Aucune chaîne ici.** Les deux libellés arrivent en `data-*`, posés par
 * `devise/shared/_password_field.html.erb` depuis `fr.yml` : le § 4.8 interdit
 * un libellé en dur, et ces vues n'ont de toute façon pas accès au catalogue
 * `ui`, qui part au navigateur par `inertia_share`.
 *
 * **Aucun garde de montage non plus.** Le script est chargé par le seul
 * gabarit `auth`, donc la boucle ne trouve rien à câbler ailleurs - c'est le
 * `querySelectorAll` qui tient ce rôle, sans condition à écrire.
 */

// Le contrat avec la vue, en un seul endroit. Une faute de frappe entre les
// deux fichiers ne lèverait rien du tout : le bouton resterait simplement
// inerte, et c'est exactement le genre de panne muette que le projet consigne.
const TOGGLE = "[data-password-toggle]"
const ICON = "[data-password-icon]"

function wire(button: HTMLElement) {
  const input = document.getElementById(button.dataset.passwordToggle ?? "")
  if (!(input instanceof HTMLInputElement)) return

  const icons = button.querySelectorAll<SVGElement>(ICON)

  button.addEventListener("click", () => {
    const reveal = input.type === "password"
    input.type = reveal ? "text" : "password"

    // Le libellé dit ce que le **prochain** clic fera, pas l'état courant :
    // c'est le nom accessible d'un bouton, il annonce une action.
    const label = reveal ? button.dataset.labelHide : button.dataset.labelShow
    if (label) {
      button.setAttribute("aria-label", label)
      button.setAttribute("title", label)
    }

    // `hidden` en attribut plutôt qu'en classe : une classe composée à
    // l'exécution n'émet aucune règle Tailwind (§ 6.1), et ici l'attribut
    // natif fait exactement le travail.
    icons.forEach((icon) => {
      icon.toggleAttribute("hidden", (icon.dataset.passwordIcon === "show") === reveal)
    })

    // Le curseur repart dans le champ, à la fin de la saisie. Sans ça, révéler
    // son mot de passe pour vérifier une frappe oblige à recliquer dedans, et
    // le navigateur y remettrait le curseur au début.
    const position = input.value.length
    input.focus()
    input.setSelectionRange(position, position)
  })
}

document.querySelectorAll<HTMLElement>(TOGGLE).forEach(wire)
